import { render, staticRenderFns } from "./EmployeeTrainingRoot.vue?vue&type=template&id=31b076e8&"
import script from "./EmployeeTrainingRoot.vue?vue&type=script&lang=ts&"
export * from "./EmployeeTrainingRoot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports